import { combineReducers } from 'redux'
import { guest }   from './guest.reducer'
import { translations } from './translations.reducer';
const rootReducer = combineReducers({
      guest:guest,  
      translations:translations
  });
  
export default rootReducer;